import type { DiagramPlugin } from "streamdown";
import type { MermaidConfig } from "mermaid";

// A drop-in replacement for @streamdown/mermaid's plugin (same defaults and initialize-once
// semantics) which dynamic-imports the mermaid engine (~2 MB) on first diagram render instead of
// pulling it into the synchronous bundle.  `DiagramPlugin`'s render() returns a Promise, so
// deferring the import inside it is contract-compliant: streamdown shows its loading placeholder
// until the promise resolves.  See also the matching manualChunks exclusions in vite.config.ts...
const defaultConfig: MermaidConfig = {
    startOnLoad: false,
    theme: "default",
    securityLevel: "strict",
    fontFamily: "monospace",
    suppressErrorRendering: true,
};

export function createLazyMermaidPlugin(): DiagramPlugin {
    let config: MermaidConfig = { ...defaultConfig };

    const instance = {
        initialize(overrides: MermaidConfig) {
            config = { ...defaultConfig, ...overrides };
        },
        async render(id: string, source: string) {
            const { default: mermaid } = await import("mermaid");
            mermaid.initialize(config);
            return await mermaid.render(id, source);
        },
    };

    return {
        name: "mermaid",
        type: "diagram",
        language: "mermaid",
        getMermaid(overrides?: MermaidConfig) {
            if (overrides) instance.initialize(overrides);
            return instance;
        },
    };
}
